import { HttpContext } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { siQuoteUrls } from '../../../environments/environment';
import { GetUserDataRequest, GetUserDataResponse, SetUserDataRequest } from "../../models/dtos";
import { BaseHttpService } from "./base-http.service";
import { UserProfileService } from "../common/user-profile.service";
import { withSilentBackgroundRequest } from '../../core/errors/http-context-tokens';


@Injectable({
  providedIn: 'root'
})
export class UserDataApiService {

  constructor(private readonly baseHttp: BaseHttpService,
     private readonly userProfileService: UserProfileService
  ) { }

  // Context is applied for a silent background API call (no global error handling or loading spinner).
  getUserData(requestBody: GetUserDataRequest): Observable<GetUserDataResponse> {
    requestBody.userId = this.userProfileService.userInfo?.gid ?? "";
    return this.baseHttp.post<GetUserDataResponse>(`${siQuoteUrls.userData}/GetUserData`, requestBody, { context: withSilentBackgroundRequest() });
  }

  setUserData(requestBody: SetUserDataRequest): Observable<boolean> {
    requestBody.userId = this.userProfileService.userInfo?.gid ?? "";
    return this.baseHttp.post<boolean>(`${siQuoteUrls.userData}/SetUserData`, requestBody);
  }
}